import Component from "@glimmer/component";
import { service } from "@ember/service";
import DTooltip from "discourse/float-kit/components/d-tooltip";
import { until } from "discourse/lib/formatter";
import dEmoji from "discourse/ui-kit/helpers/d-emoji";

export default class DUserStatusMessage extends Component {
  @service currentUser;

  get until() {
    if (!this.args.status.ends_at) {
      return;
    }

    const timezone = this.currentUser
      ? this.currentUser.user_option?.timezone
      : moment.tz.guess();

    return until(this.args.status.ends_at, timezone, this.currentUser?.locale);
  }

  <template>
    {{#if @status}}
      <DTooltip
        class="user-status-message"
        ...attributes
        @identifier="user-status-message-tooltip"
      >
        <:trigger>
          {{dEmoji @status.emoji skipTitle=true}}
          {{#if @showDescription}}
            <span class="user-status-message-description">
              {{@status.description}}
            </span>
          {{/if}}
        </:trigger>
        <:content>
          {{dEmoji @status.emoji skipTitle=true}}
          <div class="user-status-tooltip-wrapper">
            <span class="user-status-tooltip-description">
              {{@status.description}}
            </span>
            {{#if this.until}}
              <span class="user-status-tooltip-until">
                {{this.until}}
              </span>
            {{/if}}
          </div>
        </:content>
      </DTooltip>
    {{/if}}
  </template>
}
